<template>
  <div class="certificate" v-loading="loading">
    <el-row :gutter="25">
      <el-col
        :span="6"
        v-for="(i, _i) in list"
        :key="_i"
        class="pic-box"
        v-show="i && i.certImage"
      >
        <el-image
          v-if="i && i.certImage"
          @click="showBigPic(i)"
          :src="i.certImage"
          style="width: 100%"
          fit="contain"
        ></el-image>
        <div class="cert-info" v-if="i">
          <div class="cert-title" v-if="i.title">{{ i.title }}</div>
          <div class="exam-title" v-if="i.examTitle">【{{ i.examTitle }}】</div>
        </div>
      </el-col>
    </el-row>
    <div class="empty" v-if="!list.length && !loading">您暂无证书</div>
    <el-dialog
      :title="dialogVisible.title"
      v-model="dialogVisible.show"
      width="60%"
    >
      <el-image
        v-if="dialogVisible && dialogVisible.certImage"
        :src="dialogVisible.certImage"
        style="width: 100%"
        fit="contain"
      ></el-image>
    </el-dialog>
  </div>
</template>
<script>
import { getFileFullUrl } from "@/utils";

export default {
  name: "certificate",
  data() {
    return {
      loading: true,
      dialogVisible: {
        show: false,
        certImage: "",
        title: "",
      },
      list: [],
    };
  },
  methods: {
    showBigPic(item) {
      if (!item) {
        console.warn("showBigPic: item is undefined or null");
        return;
      }
      this.dialogVisible = {
        show: true,
        certImage: item.certImage || "",
        title: item.title || "",
      };
    },
    initData() {
      this.$https
        .get("/api/my/cert/list")
        .then((res) => {
          if (res.success) {
            const data = Array.isArray(res.data) ? res.data : [];
            // 支持 certImage 和 imageUrl 两种字段名
            this.list = data
              .filter((el) => {
                // 过滤掉没有证书图片地址的项，确保 el 不是 null/undefined
                if (!el || typeof el !== "object") {
                  return false;
                }
                const img = el?.certImage || el?.imageUrl;
                return img && typeof img === "string" && img.trim().length > 0;
              })
              .map((el) => {
                // 确保 el 存在
                if (!el || typeof el !== "object") {
                  return null;
                }
                // 优先使用 certImage，如果没有则使用 imageUrl
                const img = el.certImage || el.imageUrl || "";
                // 如果已经是完整URL，直接使用；否则使用工具函数处理
                const hasProtocol = /^https?:\/\//i.test(img);
                return {
                  ...el,
                  certImage: hasProtocol ? img : getFileFullUrl(img),
                };
              })
              .filter((el) => el !== null); // 过滤掉 map 过程中可能产生的 null
          } else {
            console.error("获取证书列表失败:", res);
            this.list = [];
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("获取证书列表出错:", error);
          this.list = [];
          this.loading = false;
          this.$message?.error?.("获取证书列表失败，请稍后重试");
        });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="less">
.certificate {
  position: relative;
  padding: 50px 5%;
  .pic-box {
    text-align: center;
    margin-bottom: 50px;
    cursor: pointer;
    .cert-info {
      margin-top: 10px;
      .cert-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 4px;
        color: #333;
      }
      .exam-title {
        font-size: 13px;
        line-height: 20px;
        color: #666;
      }
    }
  }
}
</style>
